import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Preferred public origin for BooksComply (SEO / canonical / sitemap). */
export const SITE_ORIGIN = 'https://www.bookscomply.com';

/** Build an absolute www URL from a path (e.g. '/tax-return'). */
export const absoluteUrl = (path = '/') => {
  let normalized = path.startsWith('http')
    ? path
    : (path.startsWith('/') ? path : `/${path}`);

  if (normalized.startsWith(SITE_ORIGIN)) {
    return normalized.replace(/\/+$/, '') || `${SITE_ORIGIN}/`;
  }

  // Drop query string / hash for canonicals
  const qIndex = normalized.indexOf('?');
  const hIndex = normalized.indexOf('#');
  const cutAt = [qIndex, hIndex].filter((i) => i >= 0).sort((a, b) => a - b)[0];
  if (cutAt !== undefined) normalized = normalized.slice(0, cutAt);

  normalized = normalized.replace(/\/+$/, '') || '/';
  if (normalized === '/') return `${SITE_ORIGIN}/`;
  return `${SITE_ORIGIN}${normalized}`;
};

/** Upsert <link rel="canonical"> in document head. */
export const setCanonicalLink = (pathOrUrl) => {
  if (typeof document === 'undefined') return null;
  const href = absoluteUrl(pathOrUrl);
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
  return link;
};

/**
 * Sets a www canonical for the current route on every page.
 * Mount once inside the Router (e.g. App Layout).
 */
export const CanonicalLink = ({ path } = {}) => {
  const location = useLocation();

  useEffect(() => {
    const target = path || location.pathname || '/';
    setCanonicalLink(target);
  }, [path, location.pathname]);

  return null;
};
